import React, { useCallback, useRef, useState, useEffect } from 'react';
import QuizContent from './shared/QuizContent';
// import QuizContent from '../shared/QuizContent'
import QuizTitle from './shared/QuizTitle';
import QuizOptions from './shared/QuizOptions';
import QuizOption from './shared/QuizOption';
import { getQuizOptionsData } from '../constants';
// import { getQuizOptionsData } from '../../constants'
import { useTranslation } from 'react-i18next';

const HentaiPage = ({ onAnswer }) => {
  const [selectedOption, setSelectedOption] = useState('Teacher'); // Default to first option
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const videoRefs = useRef([]);
  const [isMobile, setIsMobile] = useState(false);

  // Get quiz options based on selected style
  const quizOptions = getQuizOptionsData('hentai', selectedOption);

  const videos = [
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/tentacles.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/teacher.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/collegeStudent.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/nekomimi.mp4',

    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/futanari.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/milf.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/femdom.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/pregnant.mp4',

    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/nurse.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/fantasy.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/dandere.mp4',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/idol.mp4',
  ];

  // Poster images for mobile - now dynamic based on selected style
  const posterImages = [
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/tentacles.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/teacher.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/collegeStudent.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/nekomimi.webp',

    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/futanari.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/milf.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/femdom.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/pregnant.webp',

    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/nurse.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/fantasy.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/dandere.webp',
    'https://cdnsm.swipey.ai/prelander/createsexfriend/Hentai/idol.webp',
  ];

  // Detect mobile devices
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileDevice =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      );
    setIsMobile(isMobileDevice);
  }, []);

  // Simplified video playback logic
  const playVideo = useCallback((index) => {
    const video = videoRefs.current[index];
    if (video && video.paused) {
      console.log(`Playing video ${index}`);
      video.currentTime = 0;
      video.play().catch(console.warn);
    }
  }, []);

  const stopVideo = useCallback((index) => {
    const video = videoRefs.current[index];
    if (video && !video.paused) {
      console.log(`Stopping video ${index}`);
      video.pause();
      video.currentTime = 0;
    }
  }, []);

  // Handle option hover (desktop only)
  const handleOptionHover = useCallback(
    (index, isHovering) => {
      if (!isMobile) {
        console.log(`Hover ${index}: ${isHovering}`);
        setHoveredIndex(isHovering ? index : null);

        if (isHovering) {
          // Start playing video on hover (desktop only)
          playVideo(index);
        } else {
          // Stop video on hover end (unless it's selected)
          if (
            index !==
            quizOptions.findIndex((opt) => opt.value === selectedOption)
          ) {
            stopVideo(index);
          }
        }
      }
    },
    [playVideo, stopVideo, selectedOption, quizOptions, isMobile],
  );

  // Handle option click
  const handleOptionClick = useCallback(
    (value, index) => {
      console.log(`Clicking option: ${value}`);
      setSelectedOption(value);

      // Stop all videos first
      videoRefs.current.forEach((video, i) => {
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      // Start playing the selected video
      setTimeout(() => {
        playVideo(index);
      }, 100);
    },
    [playVideo],
  );

  // Initialize videos when component mounts
  useEffect(() => {
    videoRefs.current.forEach((videoRef, index) => {
      if (videoRef) {
        // Set video properties
        videoRef.muted = true;
        videoRef.loop = true;
        videoRef.playsInline = true;
        videoRef.preload = 'metadata';
        videoRef.controls = false;

        // Hide all controls
        videoRef.style.webkitMediaControls = 'none';
        videoRef.style.webkitMediaControlsOverlayPlayButton = 'none';
        videoRef.style.webkitMediaControlsPlayButton = 'none';
        videoRef.style.webkitMediaControlsStartPlaybackButton = 'none';
        videoRef.style.webkitMediaControlsTimeline = 'none';
        videoRef.style.webkitMediaControlsVolumeSlider = 'none';
        videoRef.style.webkitMediaControlsMuteButton = 'none';
        videoRef.style.webkitMediaControlsFullscreenButton = 'none';

        // Remove controls attributes
        videoRef.removeAttribute('controls');
        videoRef.removeAttribute('controlsList');

        // Add event listeners for debugging
        videoRef.addEventListener('play', () =>
          console.log(`Video ${index} started playing`),
        );
        videoRef.addEventListener('pause', () =>
          console.log(`Video ${index} paused`),
        );
      }
    });

    // Start playing the default selected video after a short delay
    setTimeout(() => {
      const defaultIndex = quizOptions.findIndex(
        (opt) => opt.value === selectedOption,
      );
      if (defaultIndex !== -1) {
        console.log(`Starting default video: ${defaultIndex}`);
        playVideo(defaultIndex);
      }
    }, 500);
  }, [selectedOption, quizOptions, playVideo]);

  const { t } = useTranslation();

  const handleContinue = () => {
    if (selectedOption !== null) {
      onAnswer('welcome', selectedOption);
    } else {
      alert(t('select_option'));
    }
  };

  const canContinue = selectedOption;
  return (
    <div className="quizContentWrapper quizContentWrapperStep0 hentai-porn">
      <QuizContent>
        <QuizTitle>
          {t('choose')}
          <span style={{ color: '#FE6283' }}> {t('personalityText')} </span>
          {t('aiCumSlut')}
        </QuizTitle>
        <div className="step0Wrapper">
          <QuizOptions className="hentai-options">
            {quizOptions.map((option, index) => {
              const isSelected = selectedOption === option.value;
              const isHovered = hoveredIndex === index;

              return (
                <QuizOption
                  key={option.value}
                  value={option.value}
                  name="hentai"
                  onClick={() => handleOptionClick(option.value, index)}
                  onMouseEnter={() => handleOptionHover(index, true)}
                  onMouseLeave={() => handleOptionHover(index, false)}
                  className={`hentai-option ${
                    isSelected
                      ? 'selected'
                      : selectedOption !== null
                      ? 'not-selected'
                      : ''
                  }`}
                >
                  <div className="option-image">
                    <video
                      ref={(el) => (videoRefs.current[index] = el)}
                      className="step0Video"
                      muted
                      loop
                      src={videos[index]}
                      poster={posterImages[index]}
                      preload="metadata"
                      playsInline
                      alt={option.alt}
                      controls={false}
                      controlsList="nodownload nofullscreen noremoteplayback"
                    />
                    <div className="hentai-image-title">
                      <p className="hentai-image-title-text">
                        {t(option.text)}
                      </p>
                    </div>
                  </div>
                </QuizOption>
              );
            })}
          </QuizOptions>

          <button
            disabled={!canContinue}
            className="continue-button step0"
            onClick={handleContinue}
          >
            {t('next')}
          </button>
        </div>
      </QuizContent>
    </div>
  );
};

export default HentaiPage;
